import type { ArenaLayout } from './layout-types';

/** S3 Brood Depths + S4 Anomaly Rim ADVANCE routes (format: routes.ts). */
export const ROUTES_DEEP: ReadonlyArray<ArenaLayout> = [
  {
    // S3: a brood tunnel — east, a climb north, east into the nest
    id: 'brood-tunnel',
    nameKey: 'arena.brood-tunnel',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'right', len: 2300, span: 1350,
          obstacles: [{ x: 0.42, y: 0.28, radius: 60 }, { x: 0.66, y: 0.7, radius: 75, pit: true }],
        },
        {
          exit: 'up', len: 2400, span: 1400, entryAt: 0.8,
          obstacles: [
            { x: 0.28, y: 0.4, radius: 80, pit: true },
            { x: 0.7, y: 0.56, radius: 60 },
            { x: 0.56, y: 0.22, radius: 64, lava: true },
          ],
        },
        {
          exit: 'right', len: 2300, span: 1350, entryAt: 0.2,
          obstacles: [{ x: 0.52, y: 0.3, radius: 62 }, { x: 0.7, y: 0.72, radius: 70, pit: true }],
          turrets: [{ x: 0.86, y: 0.2 }],
        },
      ],
      chamber: { obstacles: [{ x: 0.78, y: 0.2, radius: 60 }, { x: 0.78, y: 0.8, radius: 60 }] },
    },
  },
  {
    // S3: a gullet — two climbs through pit lanes, then east
    id: 'brood-gullet',
    nameKey: 'arena.brood-gullet',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'up', len: 2300, span: 1450,
          obstacles: [{ x: 0.5, y: 0.4, radius: 85, pit: true }, { x: 0.2, y: 0.2, radius: 55 }],
        },
        {
          exit: 'up', len: 2400, span: 1450,
          obstacles: [
            { x: 0.24, y: 0.55, radius: 78, pit: true },
            { x: 0.76, y: 0.4, radius: 78, pit: true },
            { x: 0.5, y: 0.24, radius: 60 },
          ],
        },
        {
          exit: 'right', len: 2400, span: 1350, entryAt: 0.2,
          obstacles: [{ x: 0.5, y: 0.3, radius: 68, lava: true }, { x: 0.7, y: 0.7, radius: 60 }],
          turrets: [{ x: 0.86, y: 0.82 }],
        },
      ],
      chamber: { obstacles: [{ x: 0.24, y: 0.2, radius: 75, pit: true }, { x: 0.24, y: 0.8, radius: 75, pit: true }] },
    },
  },
  {
    // S3: a warren — west, a climb north, west again into the hive
    id: 'brood-warren',
    nameKey: 'arena.brood-warren',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'left', len: 2300, span: 1400,
          obstacles: [{ x: 0.5, y: 0.26, radius: 72, pit: true }, { x: 0.36, y: 0.74, radius: 58 }],
        },
        {
          exit: 'up', len: 2400, span: 1400, entryAt: 0.8,
          obstacles: [
            { x: 0.7, y: 0.42, radius: 80, pit: true },
            { x: 0.3, y: 0.56, radius: 60 },
            { x: 0.46, y: 0.22, radius: 64, lava: true },
          ],
          turrets: [{ x: 0.14, y: 0.12 }],
        },
        {
          exit: 'left', len: 2300, span: 1400, entryAt: 0.8,
          obstacles: [{ x: 0.5, y: 0.7, radius: 66 }, { x: 0.3, y: 0.26, radius: 72, pit: true }],
        },
      ],
      chamber: { obstacles: [{ x: 0.2, y: 0.24, radius: 60 }, { x: 0.2, y: 0.76, radius: 60 }] },
    },
  },
  {
    // S4: a rift causeway — three halls east, pits carve lanes
    id: 'rim-causeway',
    nameKey: 'arena.rim-causeway',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'right', len: 2300, span: 1400,
          obstacles: [{ x: 0.5, y: 0.5, radius: 85, pit: true }, { x: 0.74, y: 0.2, radius: 55 }],
        },
        {
          exit: 'right', len: 2500, span: 1450,
          obstacles: [
            { x: 0.3, y: 0.2, radius: 80, pit: true },
            { x: 0.3, y: 0.8, radius: 80, pit: true },
            { x: 0.66, y: 0.5, radius: 62 },
          ],
          turrets: [{ x: 0.82, y: 0.16 }, { x: 0.82, y: 0.84 }],
        },
        {
          exit: 'right', len: 2200, span: 1400,
          obstacles: [{ x: 0.46, y: 0.72, radius: 70, lava: true }, { x: 0.6, y: 0.26, radius: 60 }],
        },
      ],
      chamber: { obstacles: [{ x: 0.5, y: 0.15, radius: 75, pit: true }, { x: 0.5, y: 0.85, radius: 75, pit: true }] },
    },
  },
  {
    // S4: a spiral — north, a long run east, then down into the chamber
    id: 'rim-spiral',
    nameKey: 'arena.rim-spiral',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'up', len: 2200, span: 1400,
          obstacles: [{ x: 0.28, y: 0.3, radius: 60 }, { x: 0.72, y: 0.52, radius: 72, pit: true }],
        },
        {
          exit: 'right', len: 2600, span: 1400, entryAt: 0.2,
          obstacles: [
            { x: 0.46, y: 0.5, radius: 66 },
            { x: 0.7, y: 0.25, radius: 72, lava: true },
            { x: 0.72, y: 0.76, radius: 60 },
          ],
          turrets: [{ x: 0.9, y: 0.5 }],
        },
        {
          exit: 'down', len: 2400, span: 1400, entryAt: 0.2,
          obstacles: [{ x: 0.3, y: 0.55, radius: 62 }, { x: 0.72, y: 0.66, radius: 75, pit: true }],
        },
      ],
      chamber: { obstacles: [{ x: 0.15, y: 0.5, radius: 70, lava: true }, { x: 0.85, y: 0.5, radius: 70, lava: true }] },
    },
  },
  {
    // S4: a fracture — a drop south, a run east, a climb north
    id: 'rim-fracture',
    nameKey: 'arena.rim-fracture',
    obstacles: [],
    route: {
      segments: [
        {
          exit: 'down', len: 2300, span: 1400,
          obstacles: [{ x: 0.3, y: 0.5, radius: 75, pit: true }, { x: 0.72, y: 0.3, radius: 58 }],
        },
        {
          exit: 'right', len: 2600, span: 1400, entryAt: 0.2,
          obstacles: [
            { x: 0.5, y: 0.3, radius: 66 },
            { x: 0.66, y: 0.74, radius: 76, pit: true },
            { x: 0.32, y: 0.76, radius: 64, lava: true },
          ],
          turrets: [{ x: 0.9, y: 0.16 }],
        },
        {
          exit: 'up', len: 2400, span: 1400, entryAt: 0.8,
          obstacles: [{ x: 0.3, y: 0.42, radius: 62 }, { x: 0.72, y: 0.3, radius: 70, pit: true }],
        },
      ],
      chamber: { obstacles: [{ x: 0.5, y: 0.16, radius: 70, pit: true }, { x: 0.18, y: 0.6, radius: 60 }] },
    },
  },
];
